import React from 'react';
import StoryImage from './StoryImage';

/**
 * AdStorySlide — full-screen sponsored slide shown inside the stories viewer
 * after every 4 business story sets. Mirrors the dark, gradient-treated layout
 * of the info-only event slides and is clearly marked as promoted.
 */
export default function AdStorySlide({ ad, analytics, onOpen }) {
    return (
        <>
            <div className="absolute inset-0 bg-black">
                {ad.imageUrl || ad.avatarUrl ? (
                    <StoryImage key={ad.businessId} src={ad.imageUrl || ad.avatarUrl} alt="" className="absolute inset-0 w-full h-full object-cover" />
                ) : (
                    <div className="absolute inset-0 bg-gradient-to-br from-brand-500 to-brand-700" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 from-0% via-black/60 via-45% to-transparent to-75%" />
            </div>

            <div className="absolute inset-x-0 bottom-0 z-10 p-6 pt-16 pb-10 text-white bg-gradient-to-t from-black/85 to-transparent">
                {/* Promoted header: avatar + name + handle on the left, tag on the right */}
                <div className="flex items-center gap-3 mb-3">
                    {ad.avatarUrl ? (
                        <img src={ad.avatarUrl} alt="" className="w-10 h-10 rounded-full object-cover border-2 border-white/70" />
                    ) : null}
                    <div className="min-w-0 flex-1">
                        <p className="font-semibold leading-tight truncate">{ad.title}</p>
                        {ad.handle && <p className="text-sm text-white/70 truncate">{ad.handle}</p>}
                    </div>
                    <span className="shrink-0 inline-block px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide bg-white/20 rounded-full text-white/90">
                        Promoted
                    </span>
                </div>

                {ad.description && (
                    <p className="text-sm text-white/85 leading-relaxed line-clamp-2 mb-4">{ad.description}</p>
                )}

                {(ad.discount || ad.offerCode) && (
                    <div className="bg-white/15 rounded-xl px-4 py-3 mb-4">
                        <p className="text-xs font-semibold uppercase tracking-wide text-white/80 mb-0.5">Member offer</p>
                        <p className="font-semibold text-white">{ad.discount}</p>
                        {ad.offerCode && <p className="text-sm text-white/85 font-medium">{ad.offerCode}</p>}
                        {ad.offerNote && <p className="text-xs text-white/70 mt-0.5">{ad.offerNote}</p>}
                    </div>
                )}

                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        analytics?.trackInteraction('click_story_ad', { businessId: ad.businessId });
                        onOpen();
                    }}
                    className="inline-flex items-center justify-center gap-2 rounded-xl bg-brand-600 text-white text-sm font-semibold px-5 py-2.5 hover:bg-brand-700 transition-colors"
                >
                    Learn more
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
                    </svg>
                </button>
            </div>
        </>
    );
}